import React from 'react';
import { View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ChildNodeRenderer from 'shared/renderer/ChildNodeRenderer/ChildNodeRenderer';
import {
  isChildNodeType,
  isSectionNodeType,
  VXLNode,
} from 'shared/renderer/types';

import SectionRenderer from './SectionNodeRenderer/SectionRenderer';

export interface RendererProps {
  toRender?: VXLNode;
}

const Renderer = ({ toRender }: RendererProps) => {
  if (!toRender) {
    return null;
  }

  if (isChildNodeType(toRender)) {
    return <ChildNodeRenderer toRender={toRender} />;
  } else if (isSectionNodeType(toRender)) {
    return <SectionRenderer toRender={toRender} />;
  }

  return (
    <View>
      <BodyBaseText>oops! something went wrong</BodyBaseText>
    </View>
  );
};

export default Renderer;
